module.exports = __webpack_public_path__ + "static/media/Original Korean Article from teaching - 9ho - daedam9.6e18b764.pdf";